import { render, staticRenderFns } from "./ResepObatTabView.vue?vue&type=template&id=17f5852a&scoped=true&"
import script from "./ResepObatTabView.vue?vue&type=script&lang=ts&"
export * from "./ResepObatTabView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f5852a",
  null
  
)

export default component.exports